import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { Observable, finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { ModuleTipuriProgramService } from '../module-tipuri-program.service';
import { IAddModulTipProgramPayload, IModulTipProgramForm } from '../module-tipuri-program.interface';

@Component({
    selector: 'app-add-module-tipuri-program',
    templateUrl: './add-module-tipuri-program.component.html',
    styleUrls: ['./add-module-tipuri-program.component.scss']
})
export class AddModuleTipuriProgramComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        observatii: new FormControl('', []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddModuleTipuriProgramComponent>,
        private moduleTipuriProgramService: ModuleTipuriProgramService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    submitForm() {
        this.isLoading = true;

        const { name, observatii } = this.form.value as IModulTipProgramForm;
        const payload: IAddModulTipProgramPayload = {
            name,
            observatii
        };

        this.moduleTipuriProgramService
            .addModulTipProgram(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
